import { render, staticRenderFns } from "./LoginFormOtp.vue?vue&type=template&id=e54309b6"
import script from "./LoginFormOtp.vue?vue&type=script&lang=js"
export * from "./LoginFormOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports